import { createContext, useContext, ReactNode, type JSX } from "react";
import { Outlet } from "react-router-dom";

import useFetchSubscriptionCards from "../hooks/useFetchSubscriptionCards";

interface SubscriptionCardsContextValue {
  cards: API.Card[];
  isLoading: boolean;
}

const defaultValue: SubscriptionCardsContextValue = {
  cards: [],
  isLoading: false,
};

const SubscriptionCardsContext =
  createContext<SubscriptionCardsContextValue>(defaultValue);

interface SubscriptionCardsContextProviderProps {
  children: ReactNode;
}

export const SubscriptionCardsContextProvider = ({
  children,
}: SubscriptionCardsContextProviderProps): JSX.Element => {
  const contextValue = useFetchSubscriptionCards();

  return (
    <SubscriptionCardsContext.Provider value={contextValue}>
      {children}
    </SubscriptionCardsContext.Provider>
  );
};

export const useSubscriptionCards = (): SubscriptionCardsContextValue =>
  useContext(SubscriptionCardsContext);

export const SubscriptionCardsLayout = (): JSX.Element => (
  <SubscriptionCardsContextProvider>
    <Outlet />
  </SubscriptionCardsContextProvider>
);

export default SubscriptionCardsContext;
